(function (angular) {


    angular.module('app.insight', ['angular-appinsights']);

    angular.module('app.insight').config([
        'insightsProvider', function (insightsProvider) {
            insightsProvider.start(environment.instrumentationKey, 'purchase');
        }
    ]);

    angular.module('app.insight').run(configure);
    configure.$inject = ['$rootScope', 'insights'];

    function configure($rootScope, insights) {
        $rootScope.$on('$stateChangeSuccess',
            function (event, toState) {
                insights.flush();
            });
    }
}(angular));